import React from "react";

const TableLabel = ({leftText='',rightText=''}) => {
  console.log("leftText :",leftText)
  return (
      <div className="w-full bg-sixth px-4 text-white font-semibold flex items-center justify-between gap-6 pt-3">
        <p>{leftText}</p>
        <p>{rightText}</p>
      </div>
  );
};

export default TableLabel;
